import {
  Component,
  EventEmitter,
  Output,
  TemplateRef,
  viewChild,
} from '@angular/core';

@Component({
  selector: 'ui-menu',
  templateUrl: './menu.component.html',
  standalone: true,
})
export class MenuComponent {
  readonly templateRef = viewChild.required(TemplateRef);
  @Output() readonly closed = new EventEmitter<void>();
}
